import { styled } from '@mui/system';
import { List, ListItemButton, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import LaunchIcon from '@mui/icons-material/Launch';

export const ShipmentsCnt = styled(List)(({ theme }) => ({
  height: '100%',
  width: '30%',
  overflow: 'hidden auto',
  backgroundColor: '#FFF',
  borderBottomLeftRadius: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    width: '40%'
  },
  [theme.breakpoints.up('md')]: {
    width: '30%'
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    paddingTop: 56
  },
  '&::-webkit-scrollbar-track': {
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    borderRadius: 10,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar': {
    width: 8,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 10,
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
    backgroundColor: '#a0a0a0'
  }
}));

export const TabListItemCnt = styled(ListItemButton)({
  display: 'flex',
  justifyContent: 'space-between !important',
  padding: '16px 8px',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: '#0000000a'
  }
});

export const ListItemActionsCnt = styled(Box)({
  maxWidth: 48
});

export const ListItemLink = styled(Box)({
  flexBasis: '100%',
  textDecoration: 'none',
  color: 'inherit',
  overflow: 'hidden'
});

export const TabListItem = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  fontSize: 14,
  textTransform: 'initial',
  lineHeight: '1.3em',
  letterSpacing: '0.08333em'
});

export const ShipmentDateRange = styled('span')({
  fontSize: 13,
  paddingTop: 4
});

export const ShipmentUid = styled('span')({
  color: '#0000008a'
});

export const DestinationWrapper = styled(Box)({
  padding: '8px 0 0'
});

export const DestinationCnt = styled(Box)({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});

export const StyledLaunchIcon = styled(LaunchIcon)({
  color: '#000'
});

export const WordBreak = styled('span')({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});

export const NoData = styled(Box)({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& h4': {
    color: '#667'
  }
});

export const ShowMoreCnt = styled('li')(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  marginBottom: theme.spacing(2)
}));

export const TextGrey = styled('span')({
  color: '#0000008a'
});

export const AlertStatusCnt = styled(Box)({
  paddingRight: 8
});

export const ListItemLinkBtn = styled(Link)({
  textDecoration: 'none',
  color: 'inherit'
});
